import React, { memo, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'

import { Box, Flex, useToast, Fade } from '@chakra-ui/react'
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton'
import { redirectToNewPage, triggerLaunchdeckToast } from '../../global/helpers/global-helpers'
import { resetUpdateDsrTemplateOutcome, updateDsrTemplate } from '../actions/dsr-template-actions'
import LaunchdeckSpinner from '../../global/components/helper-components/components/LaunchdeckSpinner'


function DsrTemplateSettingsPage({
  // Parent component
  dsrProperties,
  // Redux actions
  updateDsrTemplate,
  resetUpdateDsrTemplateOutcome,
  // Redux state
  dsrTemplateId,
  isMobileView,
  updateDsrTemplateOutcome,
  templateMainContactInfo
}) {


  const toast = useToast();
  const [latestDsrProperties, setLatestDsrProperties] = useState(null)
  const [deleteButtonConfirmation, setDeleteButtonConfirmation] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)
  const { memberName, isTemplateOwner } = templateMainContactInfo || {}

  const { templateSettings } = latestDsrProperties || {};
  const { isOrgTemplate: isSharedTemplate } = templateSettings || {};

  useEffect(() => {
    if (dsrProperties) {
      setLatestDsrProperties(dsrProperties)
    }
  }, [dsrProperties]);

  useEffect(() => {
    if (updateDsrTemplateOutcome) {
      const { updateDsrTemplateStatus, sourceEvent } = updateDsrTemplateOutcome || {};

      switch (sourceEvent) {
        case ("take-template-private"):
        case ("share-template"): {
          if (updateDsrTemplateStatus) {
            toast(
              triggerLaunchdeckToast({
                useCase: "show-success-state",
                label: "Template settings successfully updated",
                isMobileView
              })
            )
          } else if (!updateDsrTemplateStatus) {
            toast(
              triggerLaunchdeckToast({
                useCase: "show-error-state",
                label: "Unfortunately something went wrong. Please try again later.",
                isMobileView
              })
            )
          }

          resetUpdateDsrTemplateOutcome()
          break;
        }
        case ("delete-template"): {
          if (updateDsrTemplateStatus) {
            redirectToNewPage(`/home`)
          } else {
            setDeleteButtonConfirmation(false)
            toast(
              triggerLaunchdeckToast({
                useCase: "show-error-state",
                label: "Unfortunately something went wrong. Please try again later.",
                isMobileView
              })
            )
          }

          setIsDeleting(false)
          break;
        }
        default: {
          console.log(`There is no such sourceEvent: ${sourceEvent}`)
          break;
        }
      }
    }
  }, [updateDsrTemplateOutcome, toast, resetUpdateDsrTemplateOutcome]);


  const handleSaveDsrProperties = (saveAction) => {
    if (dsrTemplateId && saveAction) {
      switch (saveAction) {
        case ("delete-template"): {
          setIsDeleting(true)

          updateDsrTemplate({
            sourceEvent: saveAction,
            dsrTemplateId: dsrTemplateId,
            status: 'deleted'
          })
          break;
        }
        case ("share-template"): {
          updateDsrTemplate({
            sourceEvent: saveAction,
            dsrTemplateId: dsrTemplateId,
            dsrProperties: {
              ...latestDsrProperties,
              templateSettings: {
                isOrgTemplate: true
              }
            }
          })
          break;
        }
        case ("take-template-private"): {
          updateDsrTemplate({
            sourceEvent: saveAction,
            dsrTemplateId: dsrTemplateId,
            dsrProperties: {
              ...latestDsrProperties,
              templateSettings: {
                isOrgTemplate: false
              }
            }
          })
          break;
        }
        default: {
          break;
        }
      }

    }
  }

  return (
    <Box>
      <Flex justify='space-between' align='center'>
        <Box>
          <Box color='brandDark.500' fontSize='1.5em' lineHeight='1.4em' fontWeight='600'>Template Settings</Box>
          {/* <Box color='brandDark.500' fontSize={['0.75em','0.75em','0.875em','0.875em']} fontWeight='400'>
            Manage Template settings here
          </Box> */}
        </Box>
      </Flex>

      <Box bg='white' p='1em' rounded='0.5em' border='1px solid' borderColor='gray.300' my='2em'>

        <Box color='brandDark.500' fontSize='1.25em' lineHeight='1.375em' mb='1em'>General</Box>

        <Flex w='100%' justify='space-between' align='center' py='1.5em'>


          <Box w='100%' >
            <Box mb='2em'>
              <Box lineHeight='1.25em' fontWeight='500'>
                Template Owner
              </Box>

              <Box fontSize='0.75em' lineHeight='1.25em' fontWeight='400' color='gray.500' mt='0.2em'>
                {memberName ? memberName : "-"}
              </Box>
            </Box>

            {isTemplateOwner &&
              <Flex align='flex-start' justify='space-between'>
                <Box>
                  <Box lineHeight='1.25em' fontWeight='500'>
                    Access
                  </Box>
                  <Box fontSize='0.75em' lineHeight='1.25em' fontWeight='400' color='gray.500' mt='0.2em' pr='2em'>
                    {(isSharedTemplate === true) ?
                      `Template shared with team`
                      :
                      `Private template. Only you can see & use this template to create Rooms.`
                    }
                  </Box>
                </Box>

                <Fade in={true}>
                  {isSharedTemplate === true ?

                    <LaunchdeckButton bg='brandPink.500' color='white' onClick={() => {
                      handleSaveDsrProperties('take-template-private')
                    }} label="Make it private" />
                    :
                    <LaunchdeckButton bg='brandDark.500' color='white' onClick={() => {
                      handleSaveDsrProperties('share-template')
                    }} label="Share with team" />
                  }
                </Fade>
              </Flex>
            }
          </Box>
        </Flex>
      </Box>

      {isTemplateOwner &&
        <Box bg='white' p='1em' rounded='0.5em' border='1px solid' borderColor='gray.300' my='1.5em'>
          <Box color='brandDark.500' fontSize='1.25em' lineHeight='1.375em' mb='1em'>Danger Zone</Box>

          {deleteButtonConfirmation ?
            <Fade in={true}>
              {isDeleting ? 
              <Box py='1.5em'>
                <LaunchdeckSpinner /> 
                </Box>
              :
              <Flex w='100%' justify='space-between' align='center' py='1.5em'>
                <Box>
                  <Box lineHeight='1.25em' fontWeight='500'>
                    Confirmation: Deleting template
                  </Box>
                  <Box fontSize='0.75em' lineHeight='1.25em' fontWeight='400' color='gray.500' mt='0.2em'>
                    Are you sure?
                  </Box>
                </Box>

                <Box>

                  <Flex gap={4}>
                    <LaunchdeckButton bg='gray.300' color='brandDark.500' onClick={() => {
                      setDeleteButtonConfirmation(!deleteButtonConfirmation)
                    }} label='No, keep it' />

                    <LaunchdeckButton bg='brandPink.500' color='white' onClick={() => {
                      handleSaveDsrProperties('delete-template')
                    }} label='Confirm Delete' />

                  </Flex>



                </Box>


              </Flex>
}
            </Fade>

            :
            <Flex w='100%' justify='space-between' align='center' py='1.5em'>
              <Box>
                <Box lineHeight='1.25em' fontWeight='500'>
                  Delete this Template
                </Box>
                <Box fontSize='0.75em' lineHeight='1.25em' fontWeight='400' color='gray.500' mt='0.2em'>
                  It will no longer be available to you nor your team. This action cannot be undone.
                </Box>
              </Box>

              <Box>

                <LaunchdeckButton bg='gray.100' color='#DA3739' onClick={() => {
                  setDeleteButtonConfirmation(!deleteButtonConfirmation)
                }} label='Delete' />


              </Box>


            </Flex>
          }
        </Box>
      }

    </Box>

  )

}

const mapStateToProps = (state) => {
  return {

    updateDsrTemplateOutcome: state.updateDsrTemplateOutcome.results.data,
    templateMainContactInfo: state.dsrTemplateMainContact.results,
    dsrTemplateId: state.dsrTemplateId.results,
    isMobileView: state.mobileViewMode.isMobileView
  }
}


const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateDsrTemplate,
      resetUpdateDsrTemplateOutcome
    },
    dispatch,
  )

export default memo(withRouter(connect(mapStateToProps, mapDispatchToProps)(DsrTemplateSettingsPage)))
